var module = {
    en: {
        locale: 'en-US',
        messages: {
            home_1: 'Home',
            home_2: 'Home 2',
            home_3: 'Home 3',
            home_4: 'Home 4',
            about_page: 'About Us',
            shop_page: 'Shop',
            pages_page: 'Pages',
            contact_page: 'Contact',
            eng: 'English',
            fr: 'French',
            vi: 'Vietnamese',
        }
    },
    vi: {
        locale: 'vi-VN',
        messages: {
            home_1: 'Trang Chủ',
            home_2: 'Trang Chủ 2',
            home_3: 'Trang Chủ 3',
            home_4: 'Trang Chủ 4',
            about_page: 'Về Chúng Tôi',
            shop_page: 'Cửa Hàng',
            pages_page: 'Trang Con',
            contact_page: 'Liên Hệ',
            eng: 'Tiếng Anh',
            fr: 'Tiếng Pháp',
            vi: 'Tiếng Việt',
        }
    },
    fr: {
        locale: 'fr',
        messages: {
            home_1: 'Accueil',
            home_2: 'Accueil 2',
            home_3: 'Accueil 3',
            home_4: 'Accueil 4',
            about_page: 'À Propos',
            shop_page: 'Magasin',
            pages_page: 'Des Pages',
            contact_page: 'Contact',
            eng: 'Anglais',
            fr: 'Le français',
            vi: 'Vietnamien',
        }
    }

}

export default module;